// extracted by mini-css-extract-plugin
module.exports = {"checkBox":"Checkbox3StatesWidget_checkBox__d7RsK","disabled":"Checkbox3StatesWidget_disabled__2N6XF"};